import classnames from 'classnames';

import type { JSONContent } from '@tiptap/core';
import type { CSSProperties } from 'react';
import type { SerializableNode } from '../serializer';
import { computeFont } from '../utils/fonts';
import { TestimonialsSerializer } from './Serializer';
import * as styles from './Testimonials.css';
import type { TestimonialsElementProps } from './Testimonials.types';
import Serializer from './components/Serializer';

const COLUMNS_MAP: Record<string, string> = {
  '1': 'grid-cols-1',
  '2': 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-2',
  '3': 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
  '4': 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
};

export function TestimonialsElement(props: TestimonialsElementProps) {
  const { element, children, attributes, className } = props;
  const {
    mobile_hide,
    desktop_hide,
    customAttributes,
    borderWidth,
    borderRadius,
    borderColor,
    borderStyle,
    padding,
    gap,
    shadow,
    columns,
    backgroundColor,
    nameColor,
    descriptionColor,
    messageColor,
    nameFontFamily,
    descriptionFontFamily,
    messageFontFamily,
    data = [],
    alignment,
    cardStructureV2,
    structureTiptapState,
  } = element.attrs || {};

  return (
    <div
      {...customAttributes}
      className={classnames(
        className,
        {
          'mobile:hidden': mobile_hide,
          'desktop:hidden': desktop_hide,
        },
        customAttributes?.className,
        'relative',
        'grid',
        COLUMNS_MAP[columns || '3'],
      )}
      style={
        {
          gap: gap,
          width: '100%',
          '--padding': padding,
          '--background-color': backgroundColor,
          '--name-text-color': nameColor,
          '--description-text-color': descriptionColor,
          '--message-text-color': messageColor,
          '--name-font-family': computeFont(nameFontFamily) || 'inherit',
          '--description-font-family': computeFont(descriptionFontFamily) || 'inherit',
          '--message-font-family': computeFont(messageFontFamily) || 'inherit',
          '--alignment': alignment,
        } as CSSProperties
      }
      {...attributes}
    >
      {data?.map((testimonial) => {
        if (cardStructureV2) {
          return (
            <TestimonialsSerializer
              key={testimonial.id}
              node={structureTiptapState?.content?.[0] as JSONContent & SerializableNode}
              rootClassName={'h-full'}
              rootStyle={{}}
              testimonial={testimonial}
            />
          );
        }

        return (
          <div
            key={testimonial.id}
            style={
              {
                borderWidth: borderWidth,
                borderStyle: borderStyle,
                borderColor: borderColor,
                borderRadius: borderRadius,
                boxShadow: shadow,
                padding: padding,
              } as CSSProperties
            }
            className={classnames(styles.testimonialsElement)}
          >
            <Serializer testimonial={testimonial} attributes={element.attrs} />
          </div>
        );
      })}

      {children}
    </div>
  );
}
